<app-generic-input slug='name_search' [blue]='true' [input]='true' inputAlign='right' (typing)='filter($event)'>
    <app-filters-placeholder-search class='placeholder'>
        <span>שם המנגנון</span>
    </app-filters-placeholder-search>
    <app-filters-dropdown-list-selector slug='name_search' class='popup' [data]='filtered' [empty]='empty' (selected)='select($event)' textAlign='right'>
    </app-filters-dropdown-list-selector>
</app-generic-input>